import { createApolloClient } from "../../helpers/graphQL";
export var responseClient = createApolloClient("https://ploutonion.sytbuilder.com/graphql");
